import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { ChipContext } from '@plp/data-access/interfaces';

@Pipe({
	name: 'buildChipLabel',
	standalone: true
})
export class BuildChipLabelPipe implements PipeTransform {
	constructor(private readonly titleCasePipe: TitleCasePipe) {}

	transform(
		chipContext: ChipContext,
		skipFirst: boolean,
		filterLabelLookUp: Record<string, string>,
		filterDisplayTextMap: Record<string, { label: string }>,
		sameDayDeliveryEnabled: boolean
	): string {
		const {filterType, filterLabel, categoryDetails, selectedStoreInfo, selectUserZipCode} = chipContext;
		const filterTypePrefix = filterLabelLookUp?.[filterType.key] ?? '';
		const mappedLabel = filterDisplayTextMap?.[filterLabel]?.label;
		let chipLabel: string;
		let displayLabel = filterLabel;

		if (mappedLabel != null) {
			displayLabel = mappedLabel;
		} else if (filterType.key === 'facetCatgroup' && categoryDetails?.[filterLabel]?.name) {
			displayLabel = categoryDetails[filterLabel].name;
		}

		if (!skipFirst) {
			chipLabel = `${filterTypePrefix}${displayLabel}`;
		} else {
			chipLabel = `${displayLabel}`;
		}

		const showLocation =
			filterType.key === 'facetStore' &&
			sameDayDeliveryEnabled &&
			((selectedStoreInfo?.name && displayLabel === 'Pickup') ||
				(selectUserZipCode && displayLabel !== 'Pickup'));

		if (!showLocation) {
			return chipLabel;
		}

		if (displayLabel === 'Pickup') {
			chipLabel += ` at ${this.titleCasePipe.transform(selectedStoreInfo?.name ?? '')}`;
		} else {
			chipLabel += ` to ${selectUserZipCode ?? ''}`;
		}

		return chipLabel;
	}
}
